export default __webpack_public_path__ + "static/seeding-27681934cc85e14309d79cf090ac99d2.webp";